<template>
  <div>
    <div class="mb-2">
    <p class="mb-1"><label for="payment_method" class="form-label">Método de pago *</label></p>
    <select id="payment_method" class="form-input" @change="methodUpdated" required v-model="selectMethodId">
      <option value="">-Selecciona tu método de pago-</option>
      <option
        :key="`method-${i}`"
        :value="i"
        v-for="(method, i) in availableMethods">{{ method.name }}</option>
    </select>
    <input type="hidden" name="payment_method" v-model="selectedMethodId">
  </div>

  <div class="mb-2" v-if="payments.length > 0">
    <p class="mb-1"><label for="payments" class="form-label">Cuotas *</label></p>
    <select id="payments" name="payments" class="form-input" @change="paymentsUpdated">
      <option
        :key="`payment-${payment}`"
        :value="payment"
        v-for="payment in payments">{{ payment }}</option>
    </select>
  </div>
  </div>
</template>
<script>
import { globalEventBus } from '../../_globalEventBus';
export default {
  name: 'checkout-payment-methods',
  props: {
    paymentMethods: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      availableMethods: [],
      selectMethodId: '',
      selectedMethodId: null,
      payments: [],
    }
  },
  methods: {
    methodUpdated(event) {
      let index = event.target.value;
      let selectedMethod = this.availableMethods[index];
      this.selectedMethodId = selectedMethod.id;

      this.payments = [];
      if (selectedMethod.payments != null) {
        this.payments = selectedMethod.payments;
      }

      globalEventBus.$emit('paymentMethodUpdated', selectedMethod);
    },
    paymentsUpdated(event) {
      globalEventBus.$emit('paymentsUpdated', event.target.value);
    }
  },
  mounted() {
    this.availableMethods = this.paymentMethods;

    // Global event bus
    globalEventBus.$on('paymentMethodsUpdated', methods => {
      this.availableMethods = methods;
      this.selectMethodId = '';
      this.selectedMethodId = null;
      this.payments = [];
    });
  }
}
</script>
